import React, { Component } from "react";
import HeaderComponent from "../../components/Header";

import "./deleteAccount.css";

class DeleteAccountComponent extends Component {
  render() {
    return (
      <div>
        <div className="delete-account-section">
          <h2>Account Deletion Request</h2>
          <p>
            To delete your HeliTaxii account and all associated data:
          </p>
          <div className="contact-info">
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:info@helitaxii.com">info@helitaxii.com</a>
            </p>
            <p>
              <strong>Subject:</strong> Account Deletion Request
            </p>
            <p>
              <strong>Phone:</strong>{" "}
              <a href="tel:+919400399999">+91-94003 99999</a>
            </p>
          </div>
          <p>
            Include your registered email address for verification.
          </p>
          <p>
            We will process your request within 30 days.
          </p>
        </div>
        <footer id="footer" className="footer-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 conditions" align="center">
                <ul style={{ listStyle: "none" }}>
                  <li>
                    <a href="/#top">Home</a>
                  </li>
                  <li>
                    <a href="/about-us">About Us</a>
                  </li>
                  <li>
                    <a href="https://thumbyaviation.com/#CONTACT">Contact Us</a>
                  </li>
                  <li>
                    <a href="/terms-and-conditions">T&amp;C</a>
                  </li>
                  <li>
                    <a href="/privacy-policy">Privacy Policy</a>
                  </li>
                </ul>
                <div className="clearfix" />
              </div>
              <div
                className="col-lg-12"
                style={{
                  textAlign: "center",
                  paddingTop: "20px",
                  paddingBottom: "20px",
                  fontSize: "18px",
                }}
              >
                <b>© {new Date().getFullYear()} Thumby Aviation Pvt. Ltd - All Rights Reserved</b>
                <br />
                <p style={{ lineHeight: "30px", fontSize: "16px" }}>
                  Call : +91-9400399999
                </p>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default DeleteAccountComponent;
